import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { SelectLocationMapBodyComponent } from './components/select-location-body/select-location-body.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MapAddressSearchComponent } from './components/address-search/address-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextFieldModule } from '@angular/cdk/text-field';

@NgModule({
  declarations: [SelectLocationMapBodyComponent, MapAddressSearchComponent],
  imports: [
    CommonModule,
    GoogleMapsModule,
    TextFieldModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule.forChild({
      extend: true
    }),
    NgxSpinnerModule
  ],
  exports: [SelectLocationMapBodyComponent, MapAddressSearchComponent]
})
export class MapLocationSelectionModule {}
